import Card from "components/card";
import InputField from "components/fields/InputField";
import CicleExclamationIcon from "components/icons/CicleExclamationIcon";
import { useState } from "react";
import axiosClient from "axios-client.js";
import Loading from "components/loading/Loading";

const ChangePassword = () => {
    const [load, setLoad] = useState(false);
    const [message, setMessage] = useState({});
    const [state, setState] = useState({
        old_password: null,
        password: null,
        password_confirmation: null,
    });

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setState((state) => ({ ...state, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoad(true);
        setMessage({});
        axiosClient
            .put("/auth/change-password", state)
            .then(({ data }) => {
                setLoad(false);
                setMessage({ text: data.message, type: "SUCCESS" });
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    };
    return (
        <div>
            <form onSubmit={handleSubmit}>
                {load ? <Loading /> : null}
                <div className="mt-5 grid h-full grid-cols-1 gap-5">
                    <Card extra="px-4 md:px-[30px] py-2 md:py-[19px] w-full h-full sm:overflow-x-auto">
                        <div className="relative flex items-center justify-between">
                            <div className="text-2xl font-bold text-gray-800 dark:text-white">
                                Modifica password
                            </div>
                        </div>
                        <div className="mt-6 h-full">
                            {message.hasOwnProperty("text") ? (
                                <div
                                    className={
                                        "mb-6 text-left text-base " +
                                        (message.type === "SUCCESS"
                                            ? "text-green-500"
                                            : message.type === "ERROR"
                                            ? "text-red-500"
                                            : message.type === "WARNING"
                                            ? "text-amber-500"
                                            : null)
                                    }
                                >
                                    <p>{message.text}</p>
                                </div>
                            ) : null}
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                                <InputField
                                    label="Vecchia Password*"
                                    placeholder="**********"
                                    name="old_password"
                                    value={state.old_password || ""}
                                    onChange={handleChange}
                                    type="password"
                                    required={true}
                                    state={
                                        message.hasOwnProperty("errors")
                                            ? message.errors.hasOwnProperty(
                                                  "old_password"
                                              )
                                                ? "error"
                                                : null
                                            : null
                                    }
                                    error={
                                        message.hasOwnProperty("errors")
                                            ? message.errors.hasOwnProperty(
                                                  "old_password"
                                              )
                                                ? message.errors.old_password
                                                : null
                                            : null
                                    }
                                />
                                <InputField
                                    label="Nuova Password*"
                                    placeholder="**********"
                                    name="password"
                                    value={state.password || ""}
                                    onChange={handleChange}
                                    type="password"
                                    required={true}
                                    state={
                                        message.hasOwnProperty("errors")
                                            ? message.errors.hasOwnProperty(
                                                  "password"
                                              )
                                                ? "error"
                                                : null
                                            : null
                                    }
                                    error={
                                        message.hasOwnProperty("errors")
                                            ? message.errors.hasOwnProperty(
                                                  "password"
                                              )
                                                ? message.errors.password
                                                : null
                                            : null
                                    }
                                />
                                <InputField
                                    label="Conferma Nuova Password*"
                                    placeholder="**********"
                                    name="password_confirmation"
                                    value={state.password_confirmation || ""}
                                    onChange={handleChange}
                                    type="password"
                                    required={true}
                                    state={
                                        message.hasOwnProperty("errors")
                                            ? message.errors.hasOwnProperty(
                                                  "password_confirmation"
                                              )
                                                ? "error"
                                                : null
                                            : null
                                    }
                                    error={
                                        message.hasOwnProperty("errors")
                                            ? message.errors.hasOwnProperty(
                                                  "password_confirmation"
                                              )
                                                ? message.errors
                                                      .password_confirmation
                                                : null
                                            : null
                                    }
                                />
                                <div className="col-span-3">
                                    <div className="flex">
                                        <div className="mx-2 shrink-0 self-center text-gray-400">
                                            <CicleExclamationIcon />
                                        </div>
                                        <div className="mx-2 flex-1">
                                            <p className="text-sm text-gray-400">
                                                Requisiti: almeno 10 caratteri,
                                                almeno 1 lettera minuscola,
                                                almeno 1 lettera minuscola,
                                                almeno 1 numero, almeno un
                                                carattere speciale.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-1">
                            <div className="text-right">
                                <button
                                    type="submit"
                                    className="linear rounded-[8px] bg-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                                >
                                    Salva
                                </button>
                            </div>
                        </div>
                    </Card>
                </div>
            </form>
        </div>
    );
};

export default ChangePassword;
